const removeURLParameter = (url: string, parameter: string): string =>
  url
    .replace(new RegExp(`[?&]${parameter}=[^&#]*(#.*)?$`), '$1')
    .replace(new RegExp(`([?&])${parameter}=[^&]*&`), '$1');

export default removeURLParameter;
